// extracted by mini-css-extract-plugin
module.exports = {"phone":"BorrowerIndividualForm_phone__1KxNe"};